import { useState } from 'react'

const API = import.meta.env.VITE_API_URL || '/api'

function HexMark({ size = 30 }) {
  return (
    <svg className="tg-mark" viewBox="0 0 32 32" width={size} height={size} fill="none" aria-hidden="true">
      <defs>
        <clipPath id="hexFP">
          <path d="M16 3 L27 9.5 L27 22.5 L16 29 L5 22.5 L5 9.5 Z" />
        </clipPath>
      </defs>
      <rect x="0" y="0" width="32" height="18.6" fill="currentColor" opacity="0.18" clipPath="url(#hexFP)" />
      <path d="M16 3 L27 9.5 L27 22.5 L16 29 L5 22.5 L5 9.5 Z" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
      <line x1="6" y1="18.6" x2="26" y2="18.6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true); setErr('')
    try {
      const res = await fetch(API + '/auth/request-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.error || ('HTTP ' + res.status))
      }
      // Backend always returns 200 — no enumeration. Always show "check your inbox".
      setSent(true)
    } catch (e) { setErr(e.message) }
    setLoading(false)
  }

  return (
    <div className="auth-wrap">
      <section className="brand-panel">
        <div className="bp-grid" />
        <div className="bp-brand">
          <HexMark size={30} />
          <span className="wm">Tankguard</span>
        </div>
        <div className="bp-mid">
          <h1>Forgot your password?</h1>
          <p>Enter the email tied to your account and we'll send you a link to set a new password.</p>
        </div>
        <div className="bp-foot">
          <span>© 2026 Tankguard GmbH</span>
          <a href="mailto:hello@tankguard.de?subject=Privacy%20policy%20request">Privacy</a>
          <a href="mailto:hello@tankguard.de?subject=Imprint%20request">Imprint</a>
          <span>Data hosted in Germany</span>
        </div>
      </section>

      <section className="form-panel">
        <div className="fp-top" />
        <div className="fp-body">
          <div className="fp-inner">
            {sent ? (
              <>
                <h2>Check your inbox</h2>
                <p className="sub">If <strong>{email}</strong> is registered, you'll receive a reset link within a minute. The link expires in 60 minutes.</p>
                <div style={{ marginTop: 'var(--tg-space-6)' }}>
                  <a href="/" className="link">← Back to sign in</a>
                </div>
              </>
            ) : (
              <>
                <h2>Reset password</h2>
                <p className="sub">Enter your work email and we'll send a reset link.</p>
                <form className="form" onSubmit={handleSubmit}>
                  <div className="tg-field">
                    <label className="tg-label" htmlFor="fp-email">Work email</label>
                    <input
                      id="fp-email" className="tg-input" type="email"
                      value={email} onChange={e => setEmail(e.target.value)}
                      placeholder="you@company.com" autoComplete="email" required autoFocus
                    />
                  </div>
                  {err && <p className="tg-error">{err}</p>}
                  <button
                    type="submit"
                    className={`tg-btn tg-btn--lg tg-btn--primary btn-full${loading ? ' is-loading' : ''}`}
                    disabled={loading || !email}
                  >
                    <span className="tg-spinner" aria-hidden="true" />
                    {loading ? 'Sending…' : 'Send reset link'}
                  </button>
                </form>
                <div className="switch-line">
                  Remembered it? <a href="/" className="link">Back to sign in</a>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}
